// react
import React from "react";
import { Link } from "react-router-dom";

export default function FooterAboutUs() {
    return (
        <div className="site-footer__widget footer-about">
            {/* <h5 className="footer-about__title">About</h5> */}
            <div className="footer-about__text">
                Sistem Affiliate PRO  <br />
                Shopping dan Jana Income <br />
                Direct Kilang{" "}
            </div>
            <Link to="/">
                <img src="images/logos/logo-v3.png" alt="logo" className="footer-logo" />
            </Link>
        </div>
    );
}
